<app-bringoz-data-table [uniqueId]="tableUniqueId"
                        [defaultWidths]="defaultWidths"
                        [items]="items"
                        [rowHeight]="rowHeight"
                        [resizable]="false"
                        [isLoading]="isLoading">

  <ng-template tableHeader>
    <div class="th col-branch text-ellipsis">{{ 'Branch' | translate }}</div>
    <div class="th col-phone text-ellipsis">{{ 'Phone Number' | translate }}</div>
    <div class="th col-email text-ellipsis">{{ 'Email Address' | translate }}</div>
    <div class="th col-role text-ellipsis">{{ 'Role' | translate }}</div>
    <div class="th col-sms text-ellipsis">{{ 'Receive Sms Notifications' | translate }}</div>
    <div class="th col-email-notifications text-ellipsis">{{ 'Receive Email Notifications' | translate }}</div>
    <div class="th col-actions"></div>
  </ng-template>

  <ng-template tableRow let-item>
    <div class="tr layout-row layout-align-start-center">

      <div class="td col-branch text-ellipsis layout-row layout-align-start-center">

        <app-bringoz-state-link class="text-ellipsis"
                                [permission]="'branches.get'"
                                [state]="'branch.shipper-accounts'"
                                [params]="{id: item.id}"
                                [text]="item.branchName">
        </app-bringoz-state-link>

      </div>

      <div class="td col-phone text-ellipsis layout-row layout-align-start-center">
        <span class="br-body-2 text-ellipsis">{{ item.contact.phoneNumber | bringozPhone }}</span>
      </div>

      <div class="td col-email text-ellipsis layout-row layout-align-start-center">
        <span class="br-body-2 text-ellipsis">{{ item.contact.email }}</span>
      </div>

      <div class="td col-role text-ellipsis layout-row layout-align-start-center">
        <span class="br-body-2 text-ellipsis">{{ item.contact.role }}</span>
      </div>

      <div class="td col-sms layout-row layout-align-start-center">
        @if (item.contact.allowReceiveSmsNotifications) {
          <bringoz-icon iconName="check-circle-outline" color="green-103"></bringoz-icon>
        } @else {
          <bringoz-icon iconName="close-circle-outline" color="red-103"></bringoz-icon>
        }
      </div>

      <div class="td col-email-notifications layout-row layout-align-start-center">
        @if (item.contact.allowReceiveEmailNotifications) {
          <bringoz-icon iconName="check-circle-outline" color="green-103"></bringoz-icon>
        } @else {
          <bringoz-icon iconName="close-circle-outline" color="red-103"></bringoz-icon>
        }
      </div>

      <div class="td col-actions layout-row layout-align-center-center">
        <bringoz-button aria-label="Delete"
                        *ngxPermissionsOnly="'selfprofile.update'"
                        type="tertiary"
                        size="fit"
                        (onClick)="onDelete.emit(item.id)">
          <bringoz-icon iconName="trash" size="sm"></bringoz-icon>
        </bringoz-button>
      </div>

    </div>
  </ng-template>

  <app-empty-state tableEmptyState
                   src="assets/images/empty_state/empty_state_location_box.svg"
                   text="No branch contacts found">
  </app-empty-state>

</app-bringoz-data-table>
